import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IResult } from '../../../httpClient/serverApi/types/IResponse';

export interface SingleLUIDRequestParams {
    luid: string;
}

export class DeleteCredentialRequest extends Request<SingleLUIDRequestParams, IResult> {
  constructor(luidParams: SingleLUIDRequestParams) {
    super('deleteCredential', luidParams);
  }
}